import { buildApiUrl } from '../config';

export const userSignup = async (data: any) => {
  const response = await fetch(buildApiUrl('/api/users/signup'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Signup failed');
  }
  return response.json();
};

export const userLogin = async (data: any) => {
  const response = await fetch(buildApiUrl('/api/users/login'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Login failed');
  }
  return response.json();
};

export const getUserProfile = async (token: string) => {
  const response = await fetch(buildApiUrl('/api/users/me'), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch profile');
  }
  return response.json();
};

export const updateUserProfile = async (token: string, data: any) => {
  const response = await fetch(buildApiUrl('/api/users/me'), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to update profile');
  }
  return response.json();
};

export const changePassword = async (token: string, data: any) => {
  const response = await fetch(buildApiUrl('/api/users/me/change-password'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to change password');
  }
  return response.json();
};

export const getUserOrders = async (token: string) => {
  const response = await fetch(buildApiUrl('/api/users/me/orders'), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!response.ok) {
    throw new Error('Failed to fetch orders');
  }
  return response.json();
};

export const forgotPassword = async (email: string) => {
  const response = await fetch(buildApiUrl('/api/users/forgot-password'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to request password reset');
  }
  return response.json();
};

export const resetPassword = async (data: { token: string; newPassword: string; confirmPassword: string }) => {
  const response = await fetch(buildApiUrl('/api/users/reset-password'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to reset password');
  }
  return response.json();
};
